import { observer } from 'mobx-react-lite'
import { store } from '../../../stores/store'
import { useSvidQuery } from '../../../hooks/useSvidQuery'
import { getResolvedSvid } from '../../../utils/svidQuery'
import { buildParentsBannerQrValue } from '../../../utils/parentsBannerQr'
import type { ParentsInfoBannerRenderId } from './parentsInfoBannerTypes'
import QrCode from '@/src/components/ui/QrCode'
import { AnimatePresence, motion } from 'motion/react'
import { parentsInfoBannerBlockVariants } from '@/src/lib/motionVariants'
import ParentsInfoBannerBlock from './ParentsInfoBannerBlocks'

export {
    PARENTS_INFO_BANNER_HEIGHT,
    PARENTS_INFO_BANNER_TOTAL_HEIGHT,
    PARENTS_INFO_BANNER_VERTICAL_PADDING,
} from './parentsInfoBannerConstants'

const LOGO_SRC = '/images/ParentBannerLogo.png'
const QR_BOX_SIZE = 360
const QR_SIZE = 312

const ParentsInfoBanner = observer(function ParentsInfoBanner() {
    const activeBlock = store.parentsInfoBannerBlock
    const renderBlock: ParentsInfoBannerRenderId = activeBlock ?? 'placeholder'

    const svidQuery = useSvidQuery()
    const refDocumentId = store.entryReferrerLandingMatch?.mapping?.documentId ?? null
    const qrValue = buildParentsBannerQrValue(getResolvedSvid(svidQuery), refDocumentId)

    return (
        <div className='relative flex flex-col justify-between items-center px-32 w-full h-full'>
            <img
                src={LOGO_SRC}
                alt='neue leben LifeRush'
                className='w-139.75 h-auto object-contain'
            />
            <div className='relative flex justify-between gap-8 w-full'>
                <div className='relative flex-1 min-w-0 h-full overflow-hidden'>
                    <AnimatePresence mode='wait'>
                        <motion.div
                            key={renderBlock}
                            className='absolute inset-0'
                            variants={parentsInfoBannerBlockVariants}
                            initial='hidden'
                            animate='visible'
                            exit='exit'
                        >
                            <ParentsInfoBannerBlock blockId={renderBlock} />
                        </motion.div>
                    </AnimatePresence>
                </div>
                <div className='flex flex-col items-center gap-6 bg-white-stroke-even-darker p-8 rounded-3xl'>
                    <p
                        className='font-nunito font-bold text-[32px] text-white text-center leading-[100%] whitespace-nowrap'
                    >
                        Scannen  &amp; <br></br> direkt kümmern:
                    </p>
                    <div
                        className='flex justify-center items-center bg-white rounded-3xl overflow-hidden'
                        style={{ width: QR_BOX_SIZE, height: QR_BOX_SIZE }}
                    >
                        <QrCode
                            value={qrValue}
                            size={QR_SIZE}
                            color='#06487C'
                            background='#FFFFFF'
                            margin={0}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
})

export default ParentsInfoBanner
